import update from 'immutability-helper'
import {
  // PLOP_APPEND_PATTERN_ANCHOR_ACTIONS_IMPORT
  DELETE_SROI_REPORT_PAYLOAD,
  DELETE_SROI_REPORT_PAYLOAD_SUCCESS,
  DELETE_SROI_REPORT_PAYLOAD_FAILURE,
  CLEAR_DELETE_SROI_REPORT_PAYLOAD,
  UPDATE_SROI_INPUTS_PRESET,
  UPDATE_SROI_INPUTS_PRESET_SUCCESS,
  UPDATE_SROI_INPUTS_PRESET_FAILURE,
  CLEAR_UPDATE_SROI_INPUTS_PRESET,
  GET_SROI_INPUTS_PRESET,
  GET_SROI_INPUTS_PRESET_SUCCESS,
  GET_SROI_INPUTS_PRESET_FAILURE,
  CLEAR_GET_SROI_INPUTS_PRESET,
  GET_SROI_REPORTS,
  GET_SROI_REPORTS_SUCCESS,
  GET_SROI_REPORTS_FAILURE,
  CLEAR_GET_SROI_REPORTS,
  CREATE_SROI_REPORT_PAYLOAD,
  CREATE_SROI_REPORT_PAYLOAD_SUCCESS,
  CREATE_SROI_REPORT_PAYLOAD_FAILURE,
  CLEAR_CREATE_SROI_REPORT_PAYLOAD,
  UPDATE_SROI_REPORT_PAYLOAD,
  UPDATE_SROI_REPORT_PAYLOAD_SUCCESS,
  UPDATE_SROI_REPORT_PAYLOAD_FAILURE,
  CLEAR_UPDATE_SROI_REPORT_PAYLOAD,
  GET_SROI_REPORT_PAYLOAD,
  GET_SROI_REPORT_PAYLOAD_SUCCESS,
  GET_SROI_REPORT_PAYLOAD_FAILURE,
  CLEAR_GET_SROI_REPORT_PAYLOAD,
  GET_SOCIAL_RETURN_ON_INVESTMENT_REPORT,
  GET_SOCIAL_RETURN_ON_INVESTMENT_REPORT_SUCCESS,
  GET_SOCIAL_RETURN_ON_INVESTMENT_REPORT_FAILURE,
  CLEAR_GET_SOCIAL_RETURN_ON_INVESTMENT_REPORT
} from '../actions/socialReturnOnInvestment'
import {
  INITIAL_CREATE_REDUCER,
  INITIAL_DELETE_REDUCER,
  INITIAL_GET_REDUCER,
  INITIAL_GET_RESULTS_REDUCER,
  INITIAL_UPDATE_REDUCER
} from '../../constants/reducer'
import { updateItem } from '../../helpers/reducerHelpers'

const initialState = {
  // PLOP_APPEND_PATTERN_ANCHOR_INITIAL_REDUCER
  getSroiReports: INITIAL_GET_RESULTS_REDUCER,
  socialReturnOnInvestmentReport: INITIAL_GET_REDUCER,
  sroiReportPayload: INITIAL_GET_REDUCER,
  createSroiReportPayload: INITIAL_CREATE_REDUCER,
  updateSroiReportPayload: INITIAL_UPDATE_REDUCER,
  deleteSroiReportPayload: INITIAL_DELETE_REDUCER,
  getSroiInputsPreset: INITIAL_GET_REDUCER,
  updateSroiInputsPreset: INITIAL_UPDATE_REDUCER
}

export default function socialReturnOnInvestment(state = initialState, action) {
  switch (action.type) {
    // PLOP_APPEND_PATTERN_ANCHOR_REDUCERS

    // Get sroi reports
    case GET_SROI_REPORTS:
      return update(state, {
        getSroiReports: { $merge: { isLoading: true } }
      })
    case GET_SROI_REPORTS_SUCCESS:
      return update(state, {
        getSroiReports: {
          $merge: {
            isLoading: false,
            wasLoaded: true,
            results: action.data.results
          }
        }
      })
    case GET_SROI_REPORTS_FAILURE:
      return update(state, {
        getSroiReports: {
          $merge: {
            isLoading: false,
            error: action.error
          }
        }
      })
    case CLEAR_GET_SROI_REPORTS:
      return update(state, {
        getSroiReports: { $set: initialState.getSroiReports }
      })

    // Get social return on investment report
    case GET_SOCIAL_RETURN_ON_INVESTMENT_REPORT:
      return update(state, {
        socialReturnOnInvestmentReport: {
          $merge: {
            ...initialState.socialReturnOnInvestmentReport,
            isLoading: true
          }
        }
      })
    case GET_SOCIAL_RETURN_ON_INVESTMENT_REPORT_SUCCESS:
      return update(state, {
        socialReturnOnInvestmentReport: {
          $merge: {
            isLoading: false,
            wasLoaded: true,
            data: action.data
          }
        }
      })
    case GET_SOCIAL_RETURN_ON_INVESTMENT_REPORT_FAILURE:
      return update(state, {
        socialReturnOnInvestmentReport: {
          $merge: {
            isLoading: false,
            error: action.error
          }
        }
      })
    case CLEAR_GET_SOCIAL_RETURN_ON_INVESTMENT_REPORT:
      return update(state, {
        socialReturnOnInvestmentReport: { $set: initialState.socialReturnOnInvestmentReport }
      })

    // Get sroi report
    case GET_SROI_REPORT_PAYLOAD:
      return update(state, {
        sroiReportPayload: { $merge: { isLoading: true } }
      })
    case GET_SROI_REPORT_PAYLOAD_SUCCESS:
      return update(state, {
        sroiReportPayload: {
          $merge: {
            isLoading: false,
            wasLoaded: true,
            data: action.data
          }
        }
      })
    case GET_SROI_REPORT_PAYLOAD_FAILURE:
      return update(state, {
        sroiReportPayload: {
          $merge: {
            isLoading: false,
            error: action.error
          }
        }
      })
    case CLEAR_GET_SROI_REPORT_PAYLOAD:
      return update(state, {
        sroiReportPayload: { $set: initialState.sroiReportPayload }
      })

    // Create sroi report payload
    case CREATE_SROI_REPORT_PAYLOAD:
      return update(state, {
        createSroiReportPayload: { $merge: { isLoading: true } }
      })
    case CREATE_SROI_REPORT_PAYLOAD_SUCCESS:
      return update(state, {
        createSroiReportPayload: {
          $merge: {
            isLoading: false,
            data: action.data,
            wasCreated: true
          }
        },
        getSroiReports: {
          results: {
            $push: [action.data]
          }
        }
      })
    case CREATE_SROI_REPORT_PAYLOAD_FAILURE:
      return update(state, {
        createSroiReportPayload: {
          $merge: {
            isLoading: false,
            error: action.error
          }
        }
      })
    case CLEAR_CREATE_SROI_REPORT_PAYLOAD:
      return update(state, {
        createSroiReportPayload: { $set: initialState.createSroiReportPayload }
      })

    // Update sroi report
    case UPDATE_SROI_REPORT_PAYLOAD:
      return update(state, {
        updateSroiReportPayload: { $merge: { isLoading: true } }
      })
    case UPDATE_SROI_REPORT_PAYLOAD_SUCCESS:
      return update(state, {
        updateSroiReportPayload: {
          $merge: {
            isLoading: false,
            wasUpdated: true,
            data: action.data
          }
        },
        getSroiReports: {
          results: {
            $apply: items => updateItem(items, action.data)
          }
        }
      })
    case UPDATE_SROI_REPORT_PAYLOAD_FAILURE:
      return update(state, {
        updateSroiReportPayload: {
          $merge: {
            isLoading: false,
            error: action.error
          }
        }
      })
    case CLEAR_UPDATE_SROI_REPORT_PAYLOAD:
      return update(state, {
        updateSroiReportPayload: { $set: initialState.updateSroiReportPayload }
      })

    // Delete sroi report payload
    case DELETE_SROI_REPORT_PAYLOAD:
      return update(state, {
        deleteSroiReportPayload: { $merge: { isLoading: true } }
      })
    case DELETE_SROI_REPORT_PAYLOAD_SUCCESS:
      return update(state, {
        deleteSroiReportPayload: {
          $merge: {
            isLoading: false,
            wasDeleted: true,
            data: action.data
          }
        }
      })
    case DELETE_SROI_REPORT_PAYLOAD_FAILURE:
      return update(state, {
        deleteSroiReportPayload: {
          $merge: {
            isLoading: false,
            error: action.error
          }
        }
      })
    case CLEAR_DELETE_SROI_REPORT_PAYLOAD:
      return update(state, {
        deleteSroiReportPayload: { $set: initialState.deleteSroiReportPayload }
      })

    // Get sroi inputs preset
    case GET_SROI_INPUTS_PRESET:
      return update(state, {
        getSroiInputsPreset: { $merge: { isLoading: true } }
      })
    case GET_SROI_INPUTS_PRESET_SUCCESS:
      return update(state, {
        getSroiInputsPreset: {
          $merge: {
            isLoading: false,
            wasLoaded: true,
            data: action.data
          }
        }
      })
    case GET_SROI_INPUTS_PRESET_FAILURE:
      return update(state, {
        getSroiInputsPreset: {
          $merge: {
            isLoading: false,
            error: action.error
          }
        }
      })
    case CLEAR_GET_SROI_INPUTS_PRESET:
      return update(state, {
        getSroiInputsPreset: { $set: initialState.getSroiInputsPreset }
      })

    // Update sroi inputs preset
    case UPDATE_SROI_INPUTS_PRESET:
      return update(state, {
        updateSroiInputsPreset: { $merge: { isLoading: true } }
      })
    case UPDATE_SROI_INPUTS_PRESET_SUCCESS:
      return update(state, {
        updateSroiInputsPreset: {
          $merge: {
            isLoading: false,
            wasUpdated: true,
            data: action.data
          }
        }
      })
    case UPDATE_SROI_INPUTS_PRESET_FAILURE:
      return update(state, {
        updateSroiInputsPreset: {
          $merge: {
            isLoading: false,
            error: action.error
          }
        }
      })
    case CLEAR_UPDATE_SROI_INPUTS_PRESET:
      return update(state, {
        updateSroiInputsPreset: { $set: initialState.updateSroiInputsPreset }
      })

    default:
      return state
  }
}
